import { Component, Input, Output, EventEmitter, OnInit, SimpleChanges } from '@angular/core';
import { QueryBuilderService } from 'src/app/services/query-builder.service';
import { UntypedFormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';


export interface Category {
  value: any;
  viewValue: string;
}

interface Categorys extends Array<Category> {}

export interface Sorting {
  value: any;
  viewValue: string;
}

export interface Operator {
  value: any;
  viewValue: string;
}

@Component({
  selector: 'app-text-search',
  templateUrl: './text-search.component.html',
  styleUrls: ['./text-search.component.scss']
})
export class TextSearchComponent implements OnInit {

  // FormControl instance for handling changes to the search input
  queryTextCtrl = new UntypedFormControl();
  
  // Observables to hold the list of filtered cities and persons for autocomplete
  filteredCities: Observable<any[]>;
  filteredPersons: Observable<any[]>;

  // The actual query text which is being searched
  queryText: string;

  // Define the categories available for selection
  categories: Category[] = [
    { value: [], viewValue: 'Volltext' },
    { value: 'pre_person', viewValue: 'Person' },
    { value: 'pre_location', viewValue: 'Stadt' },
  ];
  
  // Initial selection for categories
  selectedCategory = this.categories[0].value;

  // Define the sort options available for selection
  sortings: Sorting[] = [
    { value: 'alphanumeric', viewValue: 'Alphanumerisch' },
    { value: 'relevance', viewValue: 'Relevanz' }
  
  ];
  
  // Initial selection for sorting
  selectedSorting = this.sortings[0].value;

  // Define the operator options available for selection
  operators: Operator[] = [
    { value: 'and', viewValue: 'und' },
    { value: 'or', viewValue: 'oder' },
    { value: 'genau', viewValue: 'genau' },
  ];
  
  // Initial selection for operators
  selectedOperator = this.operators[0].value;

  // Input properties from parent component
  @Input()
  count: number;

  @Input()
  facet_stadt: any;

  @Input()
  facet_person: any;

  // Output property to send search information back to parent component
  @Output()
  search: EventEmitter<any> = new EventEmitter<any>();

  constructor( private queryBuilder: QueryBuilderService) { }

  ngOnInit() {

    // console.log(this.facet_stadt);
    // // Sort the facets for cities and persons alphabetically
    // this.facet_stadt.sort((a, b) => a.key.localeCompare(b.key));
    // this.facet_person.sort((a, b) => a.key.localeCompare(b.key));

    // Initialize filtered cities and persons Observable for autocompletion
    // this.filteredCities = this.queryTextCtrl.valueChanges
    //   .pipe(
    //     startWith(''),
    //     map(value => this._filter(value, 'pre_location'))
    //   );

    // this.filteredPersons = this.queryTextCtrl.valueChanges
    //   .pipe(
    //     startWith(''),
    //     map(value => this._filter(value, 'pre_person'))
    // );

    // Subscribe to changes in the FormControl instance and update query text and queryBuilder
    this.queryTextCtrl.valueChanges.subscribe(value => {
      this.queryText = value;
      this.queryBuilder.setQuerytext(value);
    });

    // Set initial values if available from query builder
    if (this.queryBuilder.getCat() !== undefined) {
      this.selectedCategory = this.queryBuilder.getCat();
    }

    if (this.queryBuilder.getOpt() !== undefined) {
      this.selectedOperator = this.queryBuilder.getOpt();
    }

    if (this.queryBuilder.getSort() !== undefined) {
      this.selectedSorting = this.queryBuilder.getSort();
    } 

    if (this.queryBuilder.getQuerytext() !== undefined) {
      this.queryText = this.queryBuilder.getQuerytext();
    }

  }


  ngOnChanges(changes: SimpleChanges) {
    
    if (changes.facet_stadt && changes.facet_stadt.currentValue) {
      console.log('facet_stadt:', changes.facet_stadt.currentValue);
      this.facet_stadt = changes.facet_stadt.currentValue.sort((a, b) => a.key.localeCompare(b.key));
      this.filteredCities = this.queryTextCtrl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value, 'pre_location'))
      );

    }

    // Check if facet_person has changed
    if (changes.facet_person && changes.facet_person.currentValue) {
      console.log('facet_person:', changes.facet_person.currentValue);
      this.facet_person = changes.facet_person.currentValue.sort((a, b) => a.key.localeCompare(b.key));
      this.filteredPersons = this.queryTextCtrl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value, 'pre_person'))
      );
    }

    console.log('selectedCategory:', this.selectedCategory);
    console.log('filteredPersons:', this.filteredPersons);
    console.log('filteredCities:', this.filteredCities);
}


private _filter(value: string, category: string): any[] {
  const filterValue = value.toLowerCase();
  if (category === 'pre_person') {
      console.log('filtering persons with value:', filterValue);
      const result = this.facet_person.filter(option => option.key.toLowerCase().includes(filterValue));
      console.log('filtered persons:', result);
      return result;
  } else if (category === 'pre_location') {
    console.log('filtering city with value:', filterValue);
    const result = this.facet_stadt.filter(option => option.key.toLowerCase().includes(filterValue));
    console.log('filtered city:', result);
    return result;
  }
  return [];
}

  // Event handlers to update query builder when user selects different options
  onSelectCat(event) {
    this.queryBuilder.setCat(event.value);
  }

  onSelectOpt(event) {
    this.queryBuilder.setOpt(event.value);
  }

  onSelectSort(event) {
    this.queryBuilder.setSort(event.value);
  }

  // Update query builder when user types in the search field
  onSearchChange(event) {
    this.queryBuilder.setQuerytext(event);
  }

  // Function to handle search submissions
  submitSearch() {
    this.search.emit({
      queryText: this.queryText,
      category: this.selectedCategory,
      sorting: this.selectedSorting,
      operator: this.selectedOperator
    });
  }

}
